import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/(evm)/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SanctionedAddressDialog"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/lib/wagmi/components/sanctioned-address-dialog.tsx");
